import Vue from 'vue'
import App from './App'
import router from './router'
import api from '@/api'
import store from '@/store'
import VueContentPlaceholders from 'vue-content-placeholders'
import ResetButton from '@/components/ResetButton'
import VueTippy, { TippyComponent } from 'vue-tippy'
import VueGtm from '@gtm-support/vue2-gtm'
import vSelect from 'vue-select'

Vue.config.productionTip = false

Vue.use(VueTippy)
Vue.component('v-select', vSelect)
Vue.component('tippy', TippyComponent)
Vue.component('reset-button', ResetButton)
Vue.use(VueContentPlaceholders)
Vue.use(api)

const isProductionEnv = process.env.NODE_ENV === 'production'
if (process.env.VUE_APP_GTM_ID) {
  Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    defer: false,
    enabled: isProductionEnv,
    debug: !isProductionEnv,
    loadScript: false,
  })
}
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
